import { useId } from 'react';

import type { WithChildren } from '@dynatrace/strato-components/core';

import { XYChartIdContext } from '../context/XYChartId.context.js';

export const XYChartIdProvider = ({ children }: WithChildren) => {
  const chartId = useId();

  return (
    <XYChartIdContext.Provider value={chartId}>
      {children}
    </XYChartIdContext.Provider>
  );
};
